import DateTools from '@/tools/date';
import * as HubAPI from '@/apis/hub';

// initial state
const state = {
  list_attribute: [{ value: 'is_refurbish' }, { value: 'is_rent' }, { value: 'attention' }],

  probeTypes: {},
};

// getters
const getters = {};

// actions
const actions = {
  get_Probe_Types(context) {
    return new Promise((resolve, reject) => {
      HubAPI.api_Get_Probe_Types()
        .then((res) => {
          context.commit('set_Probe_Types', res.data || {});
          resolve(this.probeTypes);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  get_Hub_Detail(context, settings) {
    return new Promise((resolve, reject) => {
      HubAPI.api_Get_Hub_Detail(settings.params)
        .then((res) => {
          const resData = res.data;

          if (resData) {
            const _timezone = this.state.user.timezone; // 取得其他 namespace 的 state

            resData.category = 'hub';
            resData.manufacture_date = DateTools.dateTimeZone(
              resData.manufacture_date,
              _timezone,
              'YYYY-MM-DD',
            );
            resData.updated_at = DateTools.dateTimeZone(
              resData.updated_at,
              _timezone,
              'YYYY-MM-DD HH:mm',
            );
            resData.created_at = DateTools.dateTimeZone(
              resData.created_at,
              _timezone,
              'YYYY-MM-DD HH:mm',
            );
          }

          resolve(resData);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  get_Hubs(context, settings) {
    return new Promise((resolve, reject) => {
      HubAPI.api_Get_Hubs(settings.query)
        .then((res) => {
          const resData = res.data;
          const _hashids = [];

          if (resData) {
            if (resData.hubs) {
              const _timezone = this.state.user.timezone; // 取得其他 namespace 的 state

              resData.hubs.forEach((_Hub) => {
                if (_hashids.indexOf(_Hub.hashid) === -1) _hashids.push(_Hub.hashid);

                _Hub.manufacture_date = DateTools.dateTimeZone(
                  _Hub.manufacture_date,
                  _timezone,
                  'YYYY-MM-DD',
                );
                _Hub.updated_at = DateTools.dateTimeZone(
                  _Hub.updated_at,
                  _timezone,
                  'YYYY-MM-DD',
                );
                _Hub.created_at = DateTools.dateTimeZone(
                  _Hub.created_at,
                  _timezone,
                  'YYYY-MM-DD',
                );
              });
            }
          }

          // 設定 Hashid 資訊：呼叫 Service Unit API 後才返還 res
          if (_hashids.length > 0) {
            const _query = {};
            _query.hashids = _hashids.join(',');

            this.dispatch('service_unit/get_ServiceUnits', { query: _query })
              .then((r) => {
                // 把 SUID 資料填回去
                r.service_units.forEach((_suid) => {
                  const _index_of_device = _hashids.indexOf(_suid.hashid);

                  if (_index_of_device !== -1) resData.hubs[_index_of_device].suid = _suid;
                });

                resolve(resData);
              })
              .catch((e) => {
                resolve(resData);
              });
          } else resolve(resData);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  get_Hub_Probes(context, settings) {
    return new Promise((resolve, reject) => {
      HubAPI.api_Get_Hub_Probes(settings.params)
        .then((res) => {
          const resData = res.data ? res.data.probes : [];
          //  [
          //    {
          //      id: 1,
          //      hub_hashid: 'HAxes2fd',
          //      modbus_id: '24',
          //      hashid: 'HAxes2fd_24',
          //      type: 'soil_sensor',
          //      sensor_params: [
          //        'soil_temperature',
          //        'soil_moisture',
          //        'soil_conductivity',
          //      ],
          //      status: 'active',
          //      note: '雷神',
          //    },
          //    {
          //      id: 2,
          //      hub_hashid: 'HAxes2fd',
          //      modbus_id: '25',
          //      hashid: 'HAxes2fd_25',
          //      type: 'soil_sensor',
          //      sensor_params: [
          //        'soil_temperature',
          //        'soil_moisture',
          //        'soil_conductivity',
          //      ],
          //      status: 'active',
          //      note: '大連',
          //    },
          //  ];

          if (resData) {
            // const _timezone = this.state.user.timezone; // 取得其他 namespace 的 state

            resData.category = 'probe';
            // resData.updated_at = DateTools.dateTimeZone(
            //   resData.updated_at,
            //   _timezone,
            //   'YYYY-MM-DD HH:mm',
            // );
            // resData.created_at = DateTools.dateTimeZone(
            //   resData.created_at,
            //   _timezone,
            //   'YYYY-MM-DD HH:mm',
            // );
          }

          resolve(resData);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

// mutations
const mutations = {
  set_Probe_Types(state, payload) {
    state.probeTypes = payload;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
